import { render, staticRenderFns } from "./OrderManagement.vue?vue&type=template&id=4fc424cc&scoped=true"
import script from "./OrderManagement.vue?vue&type=script&lang=js"
export * from "./OrderManagement.vue?vue&type=script&lang=js"
import style0 from "./OrderManagement.vue?vue&type=style&index=0&id=4fc424cc&prod&scoped=true&lang=scss"
import style1 from "./OrderManagement.vue?vue&type=style&index=1&id=4fc424cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc424cc",
  null
  
)

export default component.exports